<template>
  <v-navigation-drawer
    :right="!$vuetify.rtl"
    app
    v-model="inputDrawer"
    stateless
    :width="1000"
    temporary
  >
  <div align="left" class="px-3 py-3">
    <v-btn
      fab
      @click="closeShowDrawer"
      small
      elevation="4"
      color="white"
      :ripple="false"
    >
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
  </div>
  <slot name="formDetails"></slot>
</v-navigation-drawer>
</template>


<script>

export default {
props: {
  inputDrawer: {
    type: Boolean
  },
},
data() {
  return {

  };
},
mounted () {
  //
},
methods: {
  closeShowDrawer () {
    this.inputDrawer=false
  }
},
};
</script>
